export const RESET = 'EXCMTAG_UPDATE_RESET'
export const SET_ERROR = 'EXCMTAG_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMTAG_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMTAG_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMTAG_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMTAG_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMTAG_UPDATE_UPDATE_RETRIEVED'
